import React, { Component } from 'react';
import { Tooltip, Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import map from 'lodash/map';
import join from 'lodash/join';
import { TableData } from 'components/styled-components';
import { TableRow } from 'containers/Manage-Questionnaire/styled-components';
import PrescreenEditQuestionDrawer from 'containers/Manage-Questionnaire/prescreen/PrescreenEditQuestionDrawer';

class Row extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, removeAnswer: false };
  }
  openDrawer = () => this.setState({ isOpen: true });
  closeDrawer = () => this.setState({ isOpen: false });
  handleDismissRemoveAnswer = () => this.setState({ removeAnswer: false });
  openRemoveAnswerDialog = () => this.setState({ removeAnswer: true });

  render() {
    const { question } = this.props;
    return (
      <TableRow>
        <TableData>
          {join(map(question.answers, f => f.answer), ', ')}
        </TableData>
        <TableData>{question.question}</TableData>
        <TableData>
          <Tooltip content="Edit">
            <Icon
              icon={IconNames.EDIT}
              onClick={this.openDrawer}
              style={{ cursor: 'pointer' }}
            />
          </Tooltip>
        </TableData>
        <PrescreenEditQuestionDrawer
          {...this.props}
          isOpen={this.state.isOpen}
          closeDrawer={this.closeDrawer}
          isParentOpen={this.state.isOpen}
          openParen={this.openDrawer}
          question={this.props.questionForDrawer}
          mapping={true}
        />
      </TableRow>
    );
  }
}

export default Row;
